export const defaultModalsId = {
  successModal: 'SuccessModal',
  errorModal: 'ErrorModal',
};
